import * as z from "zod/v4";

export const updateLinearTicketTeam = {
  name: "updateLinearTicketTeam" as const,
  input: z.object({ linearTicketId: z.string(), teamId: z.string() }),
  output: z.object({
    success: z.boolean(),
    newTeamKey: z.string().nullable(),
    newTeamName: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
